<template>
	<div>
		<div class="home">
			<div>
				<p class="home-span">权限申请与使用情况说明</p>
			</div>
		</div>
		<div class="box">
			<span class="box-1">UKidSchool英语应用权限申请与使用情况说明</span>
			<div>
				<p class="box-5">1. 为保障UKidSchool英语产品功能实现与安全稳定运行之目的，我们可能会申请或使用操作系统的相关权限；</p>
				<p class="box-5">2. 为保障您的知情权，我们通过下列列表将产品可能申请、使用的相关操作系统权限进行展示，您可以根据实际需要对相关权限进行管理；</p>
				<p class="box-5">3. 根据产品的升级，申请、使用权限的类型与目的可能会有变动，我们将及时根据这些变动对列表进行调整，以确保您及时获悉权限的申请与使用情况；</p>
				<p class="box-5">4. 请您知悉，我们为业务与产品的功能与安全需要，我们可能也会使用第三方SDK，这些第三方也可能会申请或使用相关操作系统权限；</p>
				<p class="box-5">5. 在使用产品的过程中，您可能会使用第三方开发的H5页面或小程序，这些第三方开发开发的插件或小程序也可能因业务功能所必需而申请或使用相关操作系统权限。</p>
				<p class="box-4">Android应用权限申请与使用情况</p>
				<table class="dataintable">
					<tr>
						<th>权限名称</th>
						<th>权限功能说明</th>
						<th>使用场景和目的</th>
						<th>拒绝后果说明</th>
					</tr>
					<tr>
						<td>拍摄照片和视频</td>
						<td rowspan="2">使用拍摄照片和视频、完成扫描二维码</td>
						<td rowspan="2">用于在线上课；实现设置、更换头像功能</td>
						<td rowspan="2">可能导致无法使用在线上课的基本功能；无法设置、更换头像</td>
					</tr>
					<tr>
						<td>CAMERA</td>
					</tr>
					<tr>
						<td>麦克风</td>
						<td rowspan="2">使用麦克风录制音频</td>
						<td rowspan="2">为实现在线上课、语音跟读的基本功能</td>
						<td rowspan="2">可能导致无法使用在线上课、语音跟读的基本功能</td>
					</tr>
					<tr>
						<td>MICRO</td>
					</tr>
					<tr>
						<td>INTERNET</td>
						<td>络</td>
						<td>保障软件与服务的正常运行</td>
						<td>无法联网，无法实现产品的正常运行</td>
					</tr>
					<tr>
						<td>获取网络状态</td>
						<td rowspan="2">查看网络状态</td>
						<td rowspan="2">实现联网功能；保障软件与服务的正常运行</td>
						<td rowspan="2">可能导致无法联网，无法实现产品的正常运行</td>
					</tr>
					<tr>
						<td>ACCESS_NETW<br>ORK_STATE</td>
					</tr>
					<tr>
						<td>获取WiFi状态</td>
						<td rowspan="2">查看WiFi状态</td>
						<td rowspan="2">实现联网功能；保障软件与服务的正常运行</td>
						<td rowspan="2">可能导致无法联网，无法实现产品的正常运行</td>
					</tr>
					<tr>
						<td>ACCESS_<br>WIFI_STATE</td>
					</tr>
					<tr>
						<td>检索运行应用程序</td>
						<td rowspan="2">读取程序运行日志</td>
						<td rowspan="2">用于应用程序在运行时的状态分析，排查程序崩溃等问题</td>
						<td rowspan="2">可能导致无法实现产品的基本业务功能</td>
					</tr>
					<tr>
						<td>GET_TASKS</td>
					</tr>
					<tr>
						<td>重新设置外拨电话的路径</td>
						<td>管理外拨电话</td>
						<td>用于重定向或阻止外拨电话</td>
						<td>可能导致无法实现产品的基本业务功能</td>
					</tr>
					<tr>
						<td>访问大致位置信息</td>
						<td>根据网络获取位置</td>
						<td>用于记录账号日志，信息推送服务</td>
						<td>可能导致无法实现产品的基本业务功能</td>
					</tr>
					<tr>
						<td>访问确切位置信息</td>
						<td>GPS定位</td>
						<td>用户推送服务及商城兑换礼品发货服务</td>
						<td>可能导致无法实现产品的基本业务功能</td>
					</tr>
					<tr>
						<td>获取用户设备软件安装列表</td>
						<td>查看分享调用所需第三方软件</td>
						<td>微信分享</td>
						<td>可能导致无法分享至第三方应用</td>
					</tr>
					<tr>
						<td>获取设备标识符Android ID</td>
						<td>获取手机唯一标识符用于单点登录</td>
						<td>单点登录</td>
						<td>会导致同一个账号同时登陆多台设备</td>
					</tr>
				</table>
				<p class="box-4">Android应用权限申请与使用情况</p>
				<table class="dataintable">
					<tr>
						<th>plist中描述名称</th>
						<th>权限功能说明功能</th>
						<th>使用场景或目的</th>
						<th>拒绝提供的后果</th>
					</tr>
					<tr>
						<td>NSPhotoLi<br>braryAddU<br>sageDescri<br>ption</td>
						<td>向相册中添加内容</td>
						<td>实现设置、更换头像功能；保存个性化学习海报；</td>
						<td>可能导致无法设置、更换头像和使用个性化学习海报</td>
					</tr>
					<tr>
						<td>NSPhotoLi<br>braryUsag<br>eDescri<br>ption</td>
						<td>读取相册中内容</td>
						<td>实现设置、更换头像功能；制作个性化学习海报；</td>
						<td>可能导致无法设置、更换头像和制作个性化学习海报</td>
					</tr>
					<tr>
						<td>电话<br>(读取电话状态(设备 IMSI<br>/IMEI 号）)</td>
						<td rowspan="2">提供读取手机设备标识等信息，请您放心该权限无法监听<br>、获取您的任何通话内容与信息</td>
						<td rowspan="2">保障软件服务的安全、运营的质量及效率、判断账户状<br>态、身份验证、检测及防范安全事件、实现信息推送的基本功能</td>
						<td rowspan="2">可能导致无法实现产品的基本业务功能</td>
					</tr>
					<tr>
						<td>PHONE<br>(READ_<br>PHONE_<br>STATE)</td>
					</tr>
					<tr>
						<td>电话<br>(读取电话状态(设备 IMSI<br>/IMEI 号）)</td>
						<td rowspan="2">提供读取手机设备标识等信息，请您放心该权限无法监听<br>、获取您的任何通话内容与信息</td>
						<td rowspan="2">保障软件服务的安全、运营的质量及效率、判断账户状<br>态、身份验证、检测及防范安全事件、实现信息推送的基本功能</td>
						<td rowspan="2">可能导致无法实现产品的基本业务功能</td>
					</tr>
					<tr>
						<td>PHONE<br>(READ_<br>PHONE_<br>STATE)</td>
					</tr>
					<tr>
						<td>储存<br>(读取外置存储器)</td>
						<td rowspan="2">提供读取手机储存空间内数据的功能</td>
						<td rowspan="2">实现设置、更换头像功能；制作个性<br>化学习海报；用于应用升<br>级时临时存储应用升级包以方便您完成应用的升级</td>
						<td rowspan="2">可能导致无法实现设置、更换头像功能<br>和制作个性化学习海报；无法实现应用升级功能</td>
					</tr>
					<tr>
						<td>STORAGE<br>(READ_E<br>XTERNAL<br>_STORAGE)</td>
					</tr>
					<tr>
						<td>储存<br>(写入外置存储器)</td>
						<td rowspan="2">提供写入外部储存功能</td>
						<td rowspan="2">
							实现设置、更换头像功能；<br>保存个性化学习海报；用于下载学习/课程相关文件/<br>资料；临时存储录制的语音跟读音频<br>和课程回看视频文件，用于生成课程学习报告</td>
						<td rowspan="2">可能导致无法实现设置、更换头<br>像功能和使用个性化学习海报；无法下载学习<br>/课程相关文件/资料；无法正常查看课程学习报告；</td>
					</tr>
					<tr>
						<td>STORAGE<br>(WRITE_<br>EXTERNAL<br>_STORAGE)</td>
					</tr>
					<tr>
						<td>网络</td>
						<td>访问网</td>
						<td>实现联网功</td>
						<td>可能导致</td>
					</tr>
					<tr>
						<td>NSCamera<br>UsageDes<br>cription</td>
						<td>使用摄像头</td>
						<td>用于在线上课；实现设<br>置、更换头像功能</td>
						<td>可能导致无法使用在线上<br>课的基本功能；无法设置、更换头像</td>
					</tr>
					<tr>
						<td>NSMicroph<br>oneUsage<br>Description</td>
						<td>使用麦克风录制音频</td>
						<td>为实现在线上课<br>、语音跟读的基本功能</td>
						<td>可能导致无法使用在线上课<br>、语音跟读的基本功能</td>
					</tr>
					<tr>
						<td></td>
						<td>网络权限</td>
						<td>实现联网功能；<br>保障软件与服务的正常运行</td>
						<td>可能导致无法联网<br>无法实现产品的正常运行</td>
					</tr>
					<tr>
						<td>重新设置外拨电话的路径</td>
						<td>管理外拨电话</td>
						<td>用于重定向或阻止外拨电话</td>
						<td>可能导致无法实现产品的基本业务功能</td>
					</tr>
					<tr>
						<td>访问大致位置信息</td>
						<td>根据网络获取位置</td>
						<td>用于记录账号日志，信息推送服务</td>
						<td>可能导致无法实现产品的基本业务功能</td>
					</tr>
					<tr>
						<td>访问确切位置信息</td>
						<td>GPS定位</td>
						<td>用户推送服务及商城兑换礼品发货服务</td>
						<td>可能导致无法实现产品的基本业务功能</td>
					</tr>
					<tr>
						<td>获取用户设备软件安装列表</td>
						<td>查看分享调用所需第三方软件</td>
						<td>微信分享</td>
						<td>可能导致无法分享至第三方应用</td>
					</tr>
					<tr>
						<td>阿里云SDK</td>
						<td>收集获取SD卡数据</td>
						<td>阿里云短视频合拍</td>
						<td>无法使用视频合拍功能</td>
					</tr>
				</table>
				<p class="box-4">为实现Bugly SDK产品的基本业务功能所必须，我们将向终端用户或开发者收集终端用户在使用与SDK产品相关的功能时产生的如下个人信息</p>
				<table class="dataintable">
					<tr>
						<th>个人信息类型</th>
						<th>可选/必选</th>
						<th>处理目的及功能场景</th>
						<th>处理方式</th>
					</tr>
					<tr>
						<td>手机型号</td>
						<td>必选</td>
						<td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与手机型号有关；</td>
						<td>加密传输</td>
					</tr>
					<tr>
						<td>手机品牌</td>
						<td>必选</td>
						<td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与手机品牌有关；</td>
						<td>加密传输</td>
					</tr>
					<tr>
						<td>Android系统版本</td>
						<td>必选</td>
						<td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与Android系统版本有关</td>
						<td>加密传输</td>
					</tr>
					<tr>
						<td>Android系统api等级</td>
						<td>必选</td>
						<td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与Android系统api有关；</td>
						<td>加密传输</td>
					</tr>
					<tr>
						<td>厂商系统版本</td>
						<td>必选</td>
						<td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与厂商系统版本有关；</td>
						<td>加密传输</td>
					</tr>
					<tr>
						<td>cpu架构类型</td>
						<td>必选</td>
						<td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与cpu架构类型有关；</td>
						<td>加密传输</td>
					</tr>
					<tr>
						<td>设备是否root</td>
						<td>必选</td>
						<td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与设备是否root有关；</td>
						<td>加密传输</td>
					</tr>
					<tr>
						<td>磁盘空间占用大小</td>
						<td>必选</td>
						<td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与磁盘空间占用大小有关；</td>
						<td>加密传输</td>
					</tr>
					<tr>
						<td>sdcard空间占用大小</td>
						<td>必选</td>
						<td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与sdcard空间占用大小有关；</td>
						<td>加密传输</td>
					</tr>
					<tr>
						<td>内存空间占用大小</td>
						<td>必选</td>
						<td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与内存空间占用大小有关；</td>
						<td>加密传输</td>
					</tr>
					<tr>
						<td>网络类型</td>
						<td>必选</td>
						<td>排查崩溃问题,帮助APP提升稳定性，识别Crash等问题是否与网络类型有关；</td>
						<td>加密传输</td>
					</tr>
					<tr>
						<td>应用当前正在运行的进程名和PID</td>
						<td>必选</td>
						<td>在APP发生闪退时，判断当前进程的ANR状态，排查崩溃问题, 帮助APP提升稳定性；</td>
						<td>仅读取，不保存到本地，也不上传服务器</td>
					</tr>
				</table>
				<p class="box-4">为使用阿里云短视频SDK，我们将向终端用户或开发者收集终端用户在使用与SDK产品相关的功能时产生的如下个人信息</p>
				<table class="dataintable">
					<tr>
						<th>个人信息类型</th>
						<th>适用场景</th>
					</tr>
					<tr>
						<td>UUID</td>
						<td>通过算法计算出来的终端应用的唯一的标识，用于性能调优、故障分析兼容</td>
					</tr>
					<tr>
						<td>设备型号</td>
						<td>用于性能调优、故障分析兼容</td>
					</tr>
					<tr>
						<td>IP地址</td>
						<td>1，调用SDK的服务端相关接口2，用于性能调优、故障分析兼容</td>
					</tr>
					<tr>
						<td>WIFI状态</td>
						<td>用于判断WIFI的连通性</td>
					</tr>
					<tr>
						<td>运营商信息</td>
						<td>用于实现网络链路的选择与优化</td>
					</tr>
				</table>
				<p class="box-4">为使用MobTech ShareSDK，我们将向终端用户或开发者收集终端用户在使用与SDK产品相关的功能时产生的如下个人信息</p>
				<table class="dataintable">
					<tr>
						<th>个人信息类型</th>
						<th>配置方式</th>
					</tr>
					<tr>
						<td>系统运行信息</td>
						<td>通过重载主动数据采集控制器对应方法进行配置</td>
					</tr>
					<tr>
						<td>网络状态信息</td>
						<td>通过重载主动数据采集控制器对应方法进行配置</td>
					</tr>
					<tr>
						<td>设备标识信息</td>
						<td>通过重载主动数据采集控制器对应方法进行配置</td>
					</tr>
					<tr>
						<td>社交平台OpenID</td>
						<td>通过重载主动数据采集控制器对应方法进行配置</td>
					</tr>
					<tr>
						<td>地理位置信息</td>
						<td>通过重载主动数据采集控制器对应方法进行配置</td>
					</tr>
					<tr>
						<td>应用列表信息</td>
						<td>通过重载主动数据采集控制器对应方法进行配置</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
	import "../css/home.css";
	import rem from "../utils/rem";
	export default {
		name: "Home",
		components: {},
	};
</script>